import Api from "../config/Axios";

export const getTaskInvoice = (beid, token, user_id) => {
  const config = {
    headers: {
      Authorization:
        "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/task/invoice/${beid}`, config);
};